import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box, GlobalStyles } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './theme';
import Home from './pages/Home';
import UploadWizard from './pages/UploadWizard';

const globalStyles = {
  '*': {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  },
  body: {
    backgroundColor: '#f8fafc',
  },
  '::-webkit-scrollbar': {
    width: '8px',
  },
  '::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '4px',
    '&:hover': {
      background: '#555',
    },
  },
};

// Background gradient patterns
const BackgroundPattern = () => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: -1,
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '200%',
        height: '200%',
        transform: 'translate(-50%, -50%)',
        background: `radial-gradient(circle at 50% 50%, 
          rgba(25, 118, 210, 0.05) 0%, 
          rgba(25, 118, 210, 0.03) 25%,
          rgba(25, 118, 210, 0.02) 50%,
          rgba(25, 118, 210, 0.01) 75%,
          transparent 100%
        )`,
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(135deg, 
          rgba(255, 255, 255, 0.1) 0%,
          rgba(255, 255, 255, 0.05) 100%
        )`,
      },
    }}
  />
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={globalStyles} />
      <BackgroundPattern />
      <Router>
        <Box sx={{ 
          minHeight: '100vh',
          position: 'relative',
          zIndex: 1
        }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/upload" element={<UploadWizard />} />
          </Routes>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
